import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import URL from '../service/API_URL'
import './style.css'

const EssentialIntro = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [starting, setStarting] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (state) sessionStorage.setItem('essential_candidate', JSON.stringify(state))
  }, [state])

  const candidate = state || JSON.parse(sessionStorage.getItem('essential_candidate') || 'null')

  useEffect(() => {
    if (!candidate) navigate('/')
  }, [candidate, navigate])

  const start = async () => {
    setStarting(true)
    setError('')
    try {
      const response = await URL.essentialAPI.post('attempts', candidate)
      const payload = response.data.data
      sessionStorage.setItem('essential_attempt_id', payload.attempt_id)
      sessionStorage.setItem('essential_attempt_token', payload.attempt_token)
      navigate('/essential-placement-test', { replace: true })
    } catch (requestError) {
      const messages = requestError.response?.data?.errors
      setError(messages?.test?.[0] || requestError.response?.data?.message || 'The Essentials test cannot be started right now. Please try again later.')
    } finally {
      setStarting(false)
    }
  }

  if (!candidate) return null

  return (
    <main className="essential-shell essential-intro">
      <section className="essential-intro-card">
        <span className="essential-kicker">ESSENTIALS PLACEMENT TEST</span>
        <h1>Listening. Reading. Writing.</h1>
        <p className="essential-lead">Set aside 110 uninterrupted minutes. Every response saves automatically, and the NIEC team reviews your complete test before sharing the final result.</p>
        <div className="essential-facts">
          <div><strong>30 min</strong><span>Listening</span></div>
          <div><strong>40 min</strong><span>Reading</span></div>
          <div><strong>40 min</strong><span>Writing</span></div>
        </div>
        <ol className="essential-rules">
          <li>Use headphones and find a quiet place before you begin.</li>
          <li>Each Listening audio pair can be played once. You may pause and resume while it remains open.</li>
          <li>Listening locks before Reading begins. You cannot return to it.</li>
          <li>Reading locks before the 40-minute Writing task begins.</li>
          <li>When a section timer reaches zero, the test moves forward automatically.</li>
          <li>Your score is not shown immediately. NIEC will review the Writing response first.</li>
        </ol>
        {error && <p className="essential-error" role="alert">{error}</p>}
        <div className="essential-intro-actions">
          <button type="button" className="essential-secondary" onClick={() => navigate('/')}>Back</button>
          <button type="button" className="essential-primary" onClick={start} disabled={starting}>{starting ? 'Preparing your test…' : 'Start Listening'}</button>
        </div>
      </section>
    </main>
  )
}

export default EssentialIntro
